import { IUser } from '../stores/usersStore'
import { IRoleEnum } from '../types/router'

import axiosAuth from './axiosAuth'

export const getUsers = (controller: AbortController) =>
    axiosAuth.get<IUser[]>('/users', {
        signal: controller.signal,
    })

export const deleteUser = (id: string) => axiosAuth.delete(`/users/${id}`)

export const putUser = (id: string, role: IRoleEnum) =>
    axiosAuth.put(`/users/${id}`, role)

export const getMyAccount = (controller: AbortController) =>
    axiosAuth.get<IUser>(`/account`, {
        signal: controller.signal,
    })
